'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Anchor = require('./Anchor');

var _Anchor2 = _interopRequireDefault(_Anchor);

var _AnchorLink = require('./AnchorLink');

var _AnchorLink2 = _interopRequireDefault(_AnchorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Anchor2['default'].Link = _AnchorLink2['default'];
exports['default'] = _Anchor2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/anchor/index.js
// module id = 717
// module chunks = 0